import { HStack, Skeleton } from '@chakra-ui/react';
import { MaskIcon } from '@ui/components/MaskIcon';
import MobileSupportTooltip from '@ui/components/MobileSupportTooltip';
import { Num } from '@ui/components/Num';
import { UsdValue } from '@ui/components/Num/UsdValue';
import { Token } from '@ui/config/token';
import { useBondingCurveExpectedFee } from '@ui/hooks/bondingCurve/useBondingCurveExpectedFee';
import { useTokenConfig } from '@ui/hooks/contracts/useTokenConfig';
import { useTokenPrice } from '@ui/hooks/tokenPrice';
import React from 'react';

import { useBondingTradeDialog } from '../useBondingTradeDialog';
import { useBondingTradeForm } from './BondingTradeForm/useBondingTradeForm';

const BondingTradeInclFee = () => {
  const bondingTokenAddress = useBondingTradeDialog(
    (s) => s.bondingTokenAddress,
  );
  const buyOrSell =
    useBondingTradeForm((s) => s.fromToken) === Token.agentFun ? 'buy' : 'sell';
  const amount = useBondingTradeForm((s) => s.enteredAmount);
  const expectedFee = useBondingCurveExpectedFee({
    amount: amount,
    tokenAddress: bondingTokenAddress,
    type: buyOrSell,
  }).data;
  const price = useTokenPrice({ token: Token.agentFun }).data;
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const tokenConfig = useTokenConfig({
    token: Token.agentFun,
    tokenAddress: /*not used*/ '',
  })!;
  return (
    <Skeleton loading={!expectedFee}>
      <HStack gap="4px">
        <HStack textStyle="body2" mr="auto">
          Incl. Fee
          <MobileSupportTooltip content="1% Fee">
            <MaskIcon icon="url(/masks/info.svg)" boxSize="16px" />
          </MobileSupportTooltip>
        </HStack>
        <Num
          decimalPlaces={tokenConfig.displayDecimals}
          value={expectedFee}
          textStyle="body2Bold"
          lineClamp={1}
          wordBreak="break-all"
        />
        {tokenConfig.Icon && <tokenConfig.Icon boxSize="16px" />}
        <UsdValue
          prefix="($"
          value={expectedFee}
          price={price?.usd_price}
          suffix=")"
          textStyle="body3"
        />
      </HStack>
    </Skeleton>
  );
};

export default BondingTradeInclFee;
